module.exports = __webpack_public_path__ + "static/media/wenklogo.8c12df74.png";